<div class="page-content container">
	<div class="page-header">
		<h1>
			<p>
				{{ translationManager.getTranslation('Преглед ОПН-а') }}
			</p>
		</h1>
	</div>
	<div class="page-data shadow-sm">
		<div class="content">
			<div>
				<document-view [model]="opnDocument"></document-view>
			</div>
			<div *ngIf="userCanVote && !userAlreadyVoted">
				<div class="form-element amb-5">
					<button type="button" class="btn btn-light" (click)="setConsentStatus(true)">
						{{ translationManager.getTranslation('Слажем се') }}
					</button>
					<button type="button" class="btn btn-light" (click)="openDisapprovalModal()">
						{{ translationManager.getTranslation('Не слажем се') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<app-modal [show]="showDisapprovalModal" (onHide)="closeDisapprovalModal()"
		[title]="translationManager.getTranslation('Разлог неслагања')">
		<div class="app-modal-content">
			<div class="content">
				<textarea class="form-control" [(ngModel)]="form.elements['remark'].value"></textarea>
			</div>
			<div class="errors">
				<span *ngIf="!form.elements['remark'].value">
					<i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
					}}</span>
			</div>
		</div>
		<div class="app-modal-actions">
			<button class="btn btn-success" (click)="setConsentStatus(false)"
				[disabled]="!form.elements['remark'].value">
				<i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
			<button (click)="closeDisapprovalModal()" class="btn btn-warning">
				<i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Одустани') }}</button>
		</div>
	</app-modal>